<template>
  <button :class="`esign-btn ${className}`" @click="handleClick"><slot></slot></button>
</template>
<script>
export default {
  props: {
    type: {
      default: 'default',
      type: String,
    },
    ghost: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {}
  },
  computed: {
    className() {
      const prefix = 'esign-btn'
      let className = ''
      if (this.type && this.type !== 'default') {
        className = `${prefix}-${this.type}`
      }
      if (this.ghost) {
        className = `${className} ${prefix}-background-ghost`
      }

      return className
    },
  },
  methods: {
    handleClick(e) {
      this.$emit('click', e)
    },
  },
}
</script>
<style lang="less" scoped>
@import '../../assets/style/variable.less';

.esign-btn {
  line-height: 1.5715;
  display: inline-block;
  font-weight: 400;
  white-space: nowrap;
  text-align: center;
  background-image: none;
  border: 1px solid transparent;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  touch-action: manipulation;
  height: 32px;
  padding: 4px 15px;
  font-size: 14px;
  border-radius: 2px;
  color: #000000d9;
  border-color: #d9d9d9;
  background: #fff;
  &.esign-btn-background-ghost {
    background: transparent;
    color: #fff;
    border-color: #fff;
    &:hover {
      background: @primary-color;
      border-color: @primary-color;
      color: #fff;
    }
  }
}
.esign-btn-primary {
  background: @primary-color;
  color: #fff;
  border-color: @primary-color;
  &.esign-btn-background-ghost {
    background: transparent;
    color: @primary-color;
    border-color: @primary-color;
    &:hover {
      background: @primary-color;
      border-color: @primary-color;
      color: #fff;
    }
  }
}
</style>
